import React, { Component } from 'react';
import { Formik, Form } from 'formik';

import {
  SR_API_ACTION_PARTNER_GET_APARTMENT_TRAFIC_REPORT,
} from 'api/actionTypes';

import {
  makeApiRequestUrl,
} from 'api/createApiClient';

import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import SrBox from 'client/components/SrBox';
import ButtonDeprecated, {
  BUTTON_THEME_YELLOW,
} from 'client/components/ButtonDeprecated';
import SrText from 'client/components/SrText';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrFormikField, {
  SR_FIELD_THEME_ADMIN,
} from 'client/components/SrFormikField';

import branch from 'client/core/branch';
import PartnerActions from 'client/actions/Partner';

function getFormFields({ partnerList }) {
  return [
    {
      id: 'partnerId',
      title: 'Partner',
      type: 'select',
      properties: {
        choices: (partnerList || []).map((partner) => ({
          label: partner.displayName,
          value: partner.id,
        })),
      },
      validations: ['required'],
    },
    {
      id: 'startDate',
      title: 'start date',
      type: 'date_picker',
      properties: {
        placeholder: 'MM/DD/YYYY',
        dateFormat: 'MM/DD/YYYY',
      },
      validations: ['required'],
    },
    {
      id: 'endDate',
      title: 'end date',
      type: 'date_picker',
      properties: {
        placeholder: 'MM/DD/YYYY',
        dateFormat: 'MM/DD/YYYY',
      },
      validations: ['required'],
    },
    {
      id: 'explain',
      title: 'show records',
      type: 'yes_no',
    },
  ];
}

@branch({
  partnerList: ['partners', 'list'],
})
class SrAdminGenerateReportModal extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(PartnerActions.getPartnerList);
  }

  _onSubmitForm = (formValues) => {
    const downloadReportUrl = makeApiRequestUrl({
      actionType: SR_API_ACTION_PARTNER_GET_APARTMENT_TRAFIC_REPORT,
      actionPayload: {
        ...formValues,
        contentType: formValues.explain ? undefined : 'text/csv',
      },
    });

    global.open(downloadReportUrl);
  }

  render() {
    const { onClose, partnerList } = this.props;
    const formFields = getFormFields({ partnerList });

    return (
      <SrDarkModal onClose={onClose}>
        <SrModalContent style={{ maxWidth: 440, height: 480, marginTop: 90, overflow: 'visible' }}>
          <SrText font='whitney-sc' weight='bold' size='xl' display='block' align='center'>
            traffic report for all apartments
          </SrText>
          <Formik
            initialValues={createInitialValues({
              formFields: formFields,
            })}
            validate={createFormValidationFn(formFields)}
            onSubmit={this._onSubmitForm}
            render={(formikBag) => (
              <Form>
                {formFields.map((formField) => (
                  <SrFormikField
                    key={formField.id}
                    formField={formField}
                    formikBag={formikBag}
                    className={SR_FIELD_THEME_ADMIN}
                  />
                ))}
                <SrBox marginTop={20}>
                  <ButtonDeprecated
                    type='submit'
                    theme={BUTTON_THEME_YELLOW}
                    disabled={!formikBag.isValid}
                    onClick={formikBag.handleSubmit}
                  >
                    download
                  </ButtonDeprecated>
                </SrBox>
              </Form>
            )}
          />
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrAdminGenerateReportModal.displayName = 'SrAdminGenerateReportModal';

export default SrAdminGenerateReportModal;
